import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { FormGroup, Input } from 'reactstrap';
import InputMask from 'react-input-mask';

import { Form, Link, Description } from '../../assets/styles/components';

import ContentBox from '../../components/ContentBox';
import Submit from '../../components/Submit';
import { IS_APP } from '../../services/target';

import { Creators as PasswordCreators } from '../../store/ducks/password';

class pinPassword extends Component {
  static propTypes = {
    checkPin: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  submitPin = (e, checkPin) => {
    e.preventDefault();
    checkPin(e.target.pin.value);
  };

  render() {
    const { checkPin, loading } = this.props;
    return (
      <Fragment>
        <ContentBox title="Confirmação de identidade">
          <Description>Digite o código enviado para o seu celular.</Description>
          <Form accept-charset="UTF-8" onSubmit={e => this.submitPin(e, checkPin)}>
            <FormGroup>
              <InputMask style={{ textAlign: 'center' }} mask="999999" maskChar="*">
                {inputProps => <Input {...inputProps} placeholder="Codigo" name="pin" required />}
              </InputMask>
            </FormGroup>
            <Submit loading={loading} name="Enviar" />
          </Form>

          {!IS_APP && (
            <Fragment>
              <Link to="/signin" className="linkClean">
                Entrar
              </Link>
              <br />
              <Link to="/signup" className="linkClean">
                Criar conta
              </Link>
            </Fragment>
          )}
        </ContentBox>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.password.loading,
});

const mapDispatchToProps = dispatch => bindActionCreators(PasswordCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(pinPassword);



// WEBPACK FOOTER //
// ./src/pages/pinPassword/index.js